import { PlusIcon } from '@/assets/icons'
import { iconSizes } from '@/theme/tokens'
import {
	MemberBalanceGroup,
	MemberBreakdownItem,
} from '@/utils/balanceCalculations'
import { GetUserType } from '@orbit/api-types'
import React from 'react'
import MemberRow from './MemberRow'
import {
	HeaderActionButton,
	InlineSettledNote,
	InlineSummaryCard,
	InlineSummaryLabel,
	InlineSummaryValue,
	MemberSectionList,
	SectionBody,
	SectionHeader,
	SectionRoot,
	SectionTitle,
} from './MembersSection.styles'

interface Props {
	sortedMembers: GetUserType[]
	groups: MemberBalanceGroup[]
	expandedIds: Set<number>
	allMembers: GetUserType[]
	showCurrencyCode: boolean
	allSettled: boolean
	summaryLabel: string
	summaryValue: string
	summaryTone: 'settled' | 'owe' | 'owed' | 'mixed'
	canRecordPayup: boolean
	onToggleMember: (memberId: number) => void
	onRecordPayup: () => void
	onRecordPayupForBreakdown: (memberId: number, item: MemberBreakdownItem) => void
}

const MembersSection: React.FC<Props> = ({
	sortedMembers,
	groups,
	expandedIds,
	allMembers,
	showCurrencyCode,
	allSettled,
	summaryLabel,
	summaryValue,
	summaryTone,
	canRecordPayup,
	onToggleMember,
	onRecordPayup,
	onRecordPayupForBreakdown,
}) => (
	<SectionRoot>
		<SectionHeader>
			<SectionTitle>Balances</SectionTitle>
			{canRecordPayup && (
				<HeaderActionButton type="button" onClick={onRecordPayup}>
					<PlusIcon sx={{ fontSize: iconSizes.sm }} />
					Record Payup
				</HeaderActionButton>
			)}
		</SectionHeader>
		<SectionBody>
			<InlineSummaryCard $tone={summaryTone}>
				<InlineSummaryLabel>{summaryLabel}</InlineSummaryLabel>
				<InlineSummaryValue $tone={summaryTone}>{summaryValue}</InlineSummaryValue>
			</InlineSummaryCard>
			{allSettled && <InlineSettledNote>✓ Everyone&apos;s settled up</InlineSettledNote>}
			<MemberSectionList>
				{sortedMembers.map(member => {
					const group = groups.find(g => g.userId === member.id)
					return (
						<MemberRow
							key={member.id}
							member={member}
							group={group}
							isExpanded={expandedIds.has(member.id)}
							members={allMembers}
							showCurrencyCode={showCurrencyCode}
							onToggle={() => onToggleMember(member.id)}
							onRecordPayupForBreakdown={onRecordPayupForBreakdown}
						/>
					)
				})}
			</MemberSectionList>
		</SectionBody>
	</SectionRoot>
)

export default MembersSection
